import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";

const CustomPagination = ({ pageData, handlePaginationClick }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        my: 1,
        px: 1,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Showing page {pageData.current.currentPage || 1} of {pageData.current.pageCount}
      </Typography>
      <Pagination
        count={pageData?.current?.pageCount || 1}
        onChange={handlePaginationClick}
        color="primary"
        shape="rounded"
        variant="outlined"
        sx={{
          '& .MuiPaginationItem-root': {
            fontWeight: 600,
            borderColor: '#E2E8F0',
          },
          '& .Mui-selected': {
            backgroundColor: '#2F4058 !important',
            color: '#FFFFFF',
            borderColor: '#2F4058',
          },
        }}
      />
    </Box>
  );
};

CustomPagination.propTypes = {
  pageData: PropTypes.object.isRequired,
  handlePaginationClick: PropTypes.func.isRequired,
};

export default CustomPagination;